import env from '@/config/env';

const baseUrl = env.isProduction ? 'https://readse.si.usi.ch/api' : 'http://localhost:8080';

const routes = {
  texts: 'texts',
  documentRepos: 'documentrepos',
};

const polling = {
  interval: 5000,
};

export default {
  baseUrl,
  polling,
  routes,
};
